// Set location for Product and Business pages
// if location was not set before
//
// For Catalog page location setted by <UserCatalogLocationResolver />

import { useCallback, useEffect } from 'react';
import { LocationFullType } from '../../../components/Location/config';
import { locationActionCreators } from '../../../redux/slices/location/actionCreators';
import { useIonRouter } from '@ionic/react';
import { useTypedDispatch, useTypedSelector } from '../../../redux/hooks';
import { getNearestActiveLocation } from '../../../components/Location/helpers';

export const useLocationSetter = (location: LocationFullType | null) => {
  const { routeInfo } = useIonRouter();
  const refferedByApp = !!routeInfo.pushedByRoute;
  const selectedLocation = useTypedSelector(s => s.location.selectedLocation);
  const dispatch = useTypedDispatch();
  const setLastPlaceId = useCallback(
    (placeId: string) =>
      dispatch(locationActionCreators.setLastPlaceId(placeId)),
    [dispatch]
  );

  useEffect(() => {
    (async () => {
      if (!refferedByApp && !selectedLocation && !!location) {
        const { nearestActiveLocation } = await getNearestActiveLocation(
          location
        );
        setLastPlaceId(nearestActiveLocation.place_id);
        dispatch(locationActionCreators.selectLocation(nearestActiveLocation));
      }
    })();
  }, [dispatch, setLastPlaceId, refferedByApp, location, selectedLocation]);
};
